// extracted by mini-css-extract-plugin
export default {"commit-discussion-comments":"Comment-module__commit-discussion-comments__fCn3we7","discussion-comments-rose":"Comment-module__discussion-comments-rose__LVmBcUP"};